import React from 'react';
import PropTypes from 'prop-types';
import {Video} from '../../components';

export default class PlayerSection extends React.PureComponent {
    static propTypes = {
        introContent: PropTypes.object.isRequired
    };

    state = {
        play: false,
        active: false,
        activateVideo: () => {
            this.setState({
                play: true,
                active: true
            });
        }
    };

    playPause = () => {
        this.setState({
            play: !this.state.play
        });
    };

    closeVideo = () => {
        this.setState({
            play: false,
            active: false
        });
    };

    render() {
        const {introContent} = this.props;
        const videoId = introContent.introVideo;
        return (
            <div className="secondBlock">
                <div className="grid">
                    <div className="col l12 m12 s12">
                        <div role="presentation" className="intro-image col l6 s12" onClick={this.state.activateVideo}>
                            <img src={introContent.introImage} alt="Intro Display" />
                            <span className="bb-icon-play-icon-2" />
                        </div>
                        <div className="col l6">
                            <h3 className="subTitle3">{introContent.title}</h3>
                            <h5 className="subTitle4" dangerouslySetInnerHTML={{__html: introContent.description}} />
                        </div>
                    </div>
                </div>
                <div role="presentation" id="video-modal" className={this.state.active ? 'active' : ''} onClick={this.closeVideo}>
                    <Video
                        video={videoId}
                        active={this.state.active}
                        play={this.state.play}
                        playPauseFunc={this.playPause}
                        close={this.closeVideo}
                        buttonColor="red" />
                </div>
            </div>
        );
    }
}
